const parsedTypes = {
    "electronic_ticket": "Electronic Ticket",
    "electronic_miscellaneous_document_associated":"EMD Associated",
    "electronic_miscellaneous_document_standalone":"EMD Standalone",
}

export{
    parsedTypes
}